// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProBadge":"bee_a bhl_rj bhl_rk bhl_vh bhl_eb bhl_vf bhl_gu bhl_kh"};